import React, { FC } from 'react';
import { useStaticPermission } from 'common/auth/Authorize';
import { DataTableRowAction, DataTableRowActions } from '@utmost.co/utmost-design-system';
import { tokens } from '@beeline.com/bp-design-system';
import { useCustomObjectValuesIntl } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/translations/useCustomObjectValuesIntl';
import { CustomObject } from '@oc/pages/settings/CustomFieldsAndObjects/Objects/CustomObjectValues/CustomObject.types';

interface Props {
  customObject: CustomObject;
  onEdit: (customObject: CustomObject) => void;
  onDelete: (customObject: CustomObject) => void;
}

export const CustomObjectValuesActions: FC<React.PropsWithChildren<Props>> = ({ customObject, onEdit, onDelete }) => {
  const intl = useCustomObjectValuesIntl();
  const { DELETE, UPDATE } = useStaticPermission('CUSTOM_FIELD_DEFINITION');

  const onDeleteHandler = () => {
    onDelete(customObject);
  };

  const onEditHandler = () => {
    onEdit(customObject);
  };

  return (
    <DataTableRowActions>
      <DataTableRowAction
        dataTest="edit-custom-object-value"
        onClick={onEditHandler}
        disabled={!UPDATE}
        disabledMessage={intl.noPermissionForAction}
      >
        {intl.editCustomObject}
      </DataTableRowAction>
      <DataTableRowAction
        dataTest="delete-custom-object-value"
        onClick={onDeleteHandler}
        style={{ color: tokens.colorAlert }}
        disabled={!DELETE}
        disabledMessage={intl.noPermissionForAction}
      >
        {intl.deleteCustomObject}
      </DataTableRowAction>
    </DataTableRowActions>
  );
};
